import { render } from "./Business_TransferDetails.vue?vue&type=template&id=2b5c75b8"
import script from "./Business_TransferDetails.vue?vue&type=script&lang=js"
export * from "./Business_TransferDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__